import React from 'react';
import '../styles/chrisNote.css';

const ChrisNote = () => {
  return (
    <section className="section bg-clean-snow chris-message">
      <div className="section-inner">
        <div className="chris-content">
          <div className="chris-image">
            <img 
              src="/images/team/chrisWilhelm.png" 
              alt="Chris, Maintenance Director"
            />
          </div>
          <div className="chris-text">
            <h2>A Note on Partnership</h2>
            <p className="chris-intro">Chris Wilhelm, Maintenance Director</p>
            <blockquote>
              "After 14 years with All Seasons, 
              I've learned that true landscape care is built on partnership, not just service."
            </blockquote>
            <p>
              Your property deserves consistency. Same crew, same standards, every visit. 
              We show up when we say we will, and we treat your landscape like it's our own.
            </p>
            <p>
              High Desert climate demands expertise. Our team knows exactly when to fertilize, 
              when to prune, and how to prepare for each season. Simple as that.
            </p>
            {/* <div className="chris-signature">
              <img 
                src="/images/chrisSignature.png" 
                alt="Chris Thompson Signature"
              />
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChrisNote;